(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["edc-coin-advisor"]) return;
  try {
    
(() => {
  const KEY = 'edca-v2';
  const store = {
    get(k, fallback) { try { const v = sessionStorage.getItem(k); return v ? JSON.parse(v) : fallback; } catch { return fallback; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch {} },
    del(k) { try { sessionStorage.removeItem(k); } catch {} }
  };

  function track(name, params) {
    const data = Object.assign({ event: 'coin_advisor_' + name }, params || {});
    try { (window.dataLayer = window.dataLayer || []).push(data); } catch {}
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('coin_advisor_' + name, params || {}); } catch {}
  }

  function mount() {
    const root = document.getElementById('edca');
    if (!root || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const $ = (s) => root.querySelector(s);
    const decode = (v) => { if (typeof v !== 'string') return Array.isArray(v) ? v.map(decode) : v; const t = document.createElement('textarea'); t.innerHTML = v; return t.value; };
    const L = Object.fromEntries(Object.entries(JSON.parse($('[data-labels]').textContent)).map(([k, v]) => [k, decode(v)]));
    const panel = $('[data-panel]'), wrap = $('[data-launch-wrap]'), launch = $('[data-launch]'), launchLabel = $('[data-launch-label]');
    const dismiss = $('[data-dismiss]'), close = $('[data-close]'), reset = $('[data-reset]');
    const log = $('[data-log]'), chips = $('[data-chips]'), form = $('[data-form]'), input = $('textarea'), send = $('[data-send]');
    const rootUrl = root.dataset.root || '/';
    const page = { type: root.dataset.pageType || '', handle: root.dataset.pageType === 'product' ? root.dataset.pageHandle : '', path: location.pathname };

    // state survives page changes within the visit
    let state = store.get(KEY, null) || { sessionId: null, messages: [], transcript: [], suggestions: null };
    let busy = false, opener = null;
    const save = () => store.set(KEY, state);

    /* ---------- colors ---------- */
    function palette() {
      const scheme = root.dataset.palette || 'auto';
      let dark = scheme === 'gold';
      let accent = { home: '#f05807', gold: '#c9a15e', green: '#24452f', blue: '#1f3a57', clay: '#b8432c' }[scheme] || '#f05807';
      if (scheme === 'auto') {
        const atc = document.querySelector('#atc');
        const main = document.querySelector('#MainContent');
        if (atc) { const c = getComputedStyle(atc).backgroundColor; if (c && !/rgba\(0, 0, 0, 0\)|transparent/.test(c)) accent = c; }
        if (main) {
          const n = getComputedStyle(main).backgroundColor.match(/[\d.]+/g);
          if (n && n.length >= 3 && (n.length < 4 || Number(n[3]) > 0)) dark = (n[0] * 299 + n[1] * 587 + n[2] * 114) / 1000 < 100;
        }
      }
      root.style.setProperty('--edca-accent', accent);
      root.classList.toggle('edca-dark', dark);
      let b = 0;
      if (accent.startsWith('#')) { const h = accent.slice(1); b = (parseInt(h.slice(0, 2), 16) * 299 + parseInt(h.slice(2, 4), 16) * 587 + parseInt(h.slice(4, 6), 16) * 114) / 1000; }
      else { const n = accent.match(/[\d.]+/g); if (n) b = (n[0] * 299 + n[1] * 587 + n[2] * 114) / 1000; }
      root.style.setProperty('--edca-on-accent', b > 150 ? '#1a1408' : '#fff');
    }

    /* ---------- keep the launcher above sticky bars (mobile add to cart etc.) ---------- */
    const AVOID = '#sticky, .edct-portal .sticky, .sticky.show, [data-sticky-atc]';
    function lift() {
      let h = 0;
      document.querySelectorAll(AVOID).forEach((el) => {
        if (root.contains(el)) return;
        const s = getComputedStyle(el);
        if (s.display === 'none' || s.visibility === 'hidden' || s.position !== 'fixed') return;
        const r = el.getBoundingClientRect();
        if (r.height === 0 || r.top >= innerHeight || r.bottom < innerHeight - 4) return;
        h = Math.max(h, innerHeight - r.top);
      });
      root.style.setProperty('--edca-lift', h ? (h + 4) + 'px' : '0px');
    }
    let liftQueued = false;
    const queueLift = () => { if (liftQueued) return; liftQueued = true; requestAnimationFrame(() => { liftQueued = false; lift(); }); };
    addEventListener('scroll', queueLift, { passive: true });
    addEventListener('resize', queueLift);
    const watched = new WeakSet(), mo = new MutationObserver(() => { queueLift(); setTimeout(lift, 450); });
    const watchBars = () => document.querySelectorAll(AVOID).forEach((n) => { if (!watched.has(n)) { watched.add(n); mo.observe(n, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] }); n.addEventListener('transitionend', queueLift); } });
    watchBars(); setTimeout(() => { watchBars(); lift(); }, 1500);

    /* ---------- open / close ---------- */
    function showLauncher(on) { wrap.hidden = !on; }
    function updateLauncher() {
      const has = state.transcript.length > 0;
      root.classList.toggle('edca-has-chat', has);
      launchLabel.textContent = has ? L.resume : L.launch;
    }
    function open(prompt) {
      opener = document.activeElement;
      panel.hidden = false; showLauncher(false);
      launch.setAttribute('aria-expanded', 'true');
      store.del('edca-hidden');
      if (!log.childElementCount) renderAll();
      log.scrollTop = log.scrollHeight;
      if (matchMedia('(max-width:600px)').matches) document.documentElement.style.overflow = 'hidden';
      track('open', { page_type: page.type, resumed: state.transcript.length > 0 });
      if (prompt) ask(prompt); else setTimeout(() => input.focus({ preventScroll: true }), 50);
    }
    function shut() {
      panel.hidden = true; showLauncher(true); updateLauncher();
      launch.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      (opener && opener.isConnected && !panel.contains(opener) ? opener : launch).focus({ preventScroll: true });
    }
    function hideForVisit() {
      store.set('edca-hidden', 1); showLauncher(false); track('dismiss', { page_type: page.type });
    }

    /* ---------- rendering ---------- */
    function el(tag, cls, text) { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    function bubble(role, text, plain) {
      const m = el('div', 'edca-msg ' + (role === 'user' ? 'edca-user' : 'edca-bot' + (plain ? ' edca-plain' : '')));
      m.setAttribute('aria-label', role === 'user' ? L.you : L.advisor);
      m.append(el('p', '', text));
      return m;
    }
    function safeUrl(u) {
      try {
        const x = new URL(u, location.origin);
        const hostOk = x.hostname === location.hostname || /(^|\.)edcremindercoins\.com$/.test(x.hostname);
        if (x.protocol !== 'https:' || !hostOk || x.username || x.password) return null;
        return x.hostname === location.hostname ? x.pathname + x.search + x.hash : x.href;
      } catch { return null; }
    }
    function renderLinks(links) {
      const box = el('div', 'edca-links');
      (links || []).forEach((l) => {
        const href = safeUrl(l.url); if (!href) return;
        const a = el('a', '', l.name); a.href = href;
        a.addEventListener('click', (e) => {
          track('link_click', { link: l.key || l.name });
          if (/#wholesale$/.test(href)) {
            const f = document.getElementById('popupForm');
            if (f) { e.preventDefault(); shut(); f.style.display = 'flex'; }
          }
        });
        box.append(a);
      });
      return box.childElementCount ? box : null;
    }
    function renderEntry(t) {
      if (t.role === 'user') { if (!t.hidden) log.append(bubble('user', t.text)); return; }
      log.append(bubble('assistant', t.text, !!t.opening));
      if (t.recs && t.recs.length) {
        const box = el('div', 'edca-cards');
        t.recs.forEach((r) => box.append(card(r)));
        log.append(box);
      }
      const links = renderLinks(t.links); if (links) log.append(links);
    }
    function renderAll() {
      log.replaceChildren();
      log.append(bubble('assistant', L.opening, true));
      state.transcript.forEach(renderEntry);
      renderChips(state.transcript.length ? state.suggestions || [] : L.chips);
    }
    function renderChips(list) {
      chips.replaceChildren();
      (list || []).slice(0, 3).forEach((txt) => {
        const b = el('button', '', txt); b.type = 'button';
        b.addEventListener('click', () => ask(txt, 'chip'));
        chips.append(b);
      });
    }

    /* ---------- product cards ---------- */
    const products = {};
    function getProduct(handle) {
      if (!products[handle]) products[handle] = fetch(rootUrl.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null)).catch(() => null);
      return products[handle];
    }
    function money(cents) {
      if (window.EDCT && typeof EDCT.money === 'function') return EDCT.money(cents);
      const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || root.dataset.currency || 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
      catch { return '$' + (cents / 100).toFixed(2); }
    }
    function card(r) {
      const c = el('article', 'edca-card');
      const href = safeUrl(r.url) || (rootUrl.replace(/\/$/, '') + '/products/' + r.handle);
      const img = el('img'); img.alt = ''; img.loading = 'lazy'; img.width = 76; img.height = 76;
      if (r.image) img.src = r.image + (r.image.includes('?') ? '&' : '?') + 'width=160';
      const body = el('div');
      const h = el('h4'); const a = el('a', '', r.name); a.href = href; h.append(a);
      const price = el('div', 'edca-price');
      const reason = el('p', 'edca-reason', r.reason || '');
      const row = el('div', 'edca-row');
      body.append(h, price, reason, row);
      c.append(img, body);
      const onClick = () => track('recommendation_click', { handle: r.handle });
      a.addEventListener('click', onClick);

      getProduct(r.handle).then((p) => {
        if (!p) { const v = el('a', 'edca-viewlink', L.view); v.href = href; v.addEventListener('click', onClick); row.append(v); return; }
        if (!r.image && p.featured_image) { const f = p.featured_image.replace(/^\/\//, 'https://'); img.src = f + (f.includes('?') ? '&' : '?') + 'width=160'; }
        const variants = p.variants.filter((v) => v.available);
        if (!variants.length) { price.textContent = L.soldOut; return; }
        let current = variants[0];
        price.textContent = money(current.price);
        if (variants.length > 1) {
          const sel = el('select'); sel.setAttribute('aria-label', L.finish + ': ' + p.title);
          variants.forEach((v) => { const o = el('option', '', v.title.replace(/ Finish$/i, '')); o.value = v.id; sel.append(o); });
          sel.addEventListener('change', () => {
            current = variants.find((v) => String(v.id) === sel.value) || current;
            price.textContent = money(current.price);
            if (current.featured_image && current.featured_image.src) img.src = current.featured_image.src + (current.featured_image.src.includes('?') ? '&' : '?') + 'width=160';
          });
          row.append(sel);
        }
        const add = el('button', 'edca-add', L.add); add.type = 'button';
        add.addEventListener('click', () => addToCart(current, p, add, row));
        row.append(add);
      });
      return c;
    }
    function updateCartCount(count) {
      document.querySelectorAll('.header-cart__count,[data-cart-count],.cart-count,.cart-link__count,.js-cart-count,.header__cart-count,#CartCount,.cart-count-bubble span').forEach((n) => {
        if (n.closest('.edct') || root.contains(n)) return; n.textContent = count; n.hidden = false; n.classList.toggle('hidden', !count);
      });
    }
    async function addToCart(variant, product, btn, row) {
      btn.disabled = true; btn.textContent = L.adding;
      const item = { id: variant.id, quantity: 1, properties: { _source: 'Coin Advisor' } };
      try {
        // Mark the cart so orders that used the advisor are visible in Shopify admin.
        const markCart = () => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Coin Advisor': 'Used' } }) }).catch(() => {});
        if (false && window.EDCT && typeof EDCT.add === 'function' && document.getElementById('drawer')) { // drawer path off: the chat stays open so it can suggest an add-on
          shut();
          await EDCT.add([item]);
          await markCart();
        } else {
          const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
          const j = await r.json();
          if (!r.ok) throw new Error(j.description || j.message || L.addError);
          await markCart();
          const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((x) => x.json()).catch(() => null);
          if (cart) updateCartCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (!row.querySelector('[data-viewcart]')) {
            const v = el('a', 'edca-viewlink', L.viewCart + ' →'); v.href = root.dataset.cartUrl || '/cart'; v.dataset.viewcart = '1'; row.append(v);
          }
        }
        btn.textContent = L.added + ' ✓';
        track('add_to_cart', { handle: product.handle, variant_id: variant.id, value: variant.price / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
        setTimeout(() => { btn.disabled = false; btn.textContent = L.add; }, 4000);
        followUp(product);
      } catch (err) {
        btn.disabled = false; btn.textContent = L.add;
        const s = el('p', 'edca-status', (err && err.message) || L.addError); row.after(s); setTimeout(() => s.remove(), 5000);
      }
    }

    /* ---------- add-on suggestion after an add to cart ---------- */
    function followUp(product) {
      let tries = 0;
      const go = () => { if (busy && tries++ < 20) { setTimeout(go, 500); return; } if (!busy) ask('[Added to cart: ' + product.title + ']', 'cart', true); };
      go();
    }

    /* ---------- talking to the advisor ---------- */
    function typing() { const t = el('div', 'edca-msg edca-bot edca-typing'); t.setAttribute('aria-label', L.thinking); t.append(el('i'), el('i'), el('i')); return t; }
    async function ask(text, via, hidden) {
      text = (text || '').trim();
      if (busy || !text) return;
      busy = true; send.disabled = true; reset.disabled = true;
      if (!hidden) { input.value = ''; autosize(); }
      chips.replaceChildren();
      state.transcript.push(hidden ? { role: 'user', text, hidden: true } : { role: 'user', text });
      if (!hidden) log.append(bubble('user', text));
      const dots = typing(); log.append(dots); log.scrollTop = log.scrollHeight;
      const proposed = [...state.messages, { role: 'user', content: text }].slice(-20);
      track('message', { via: via || 'typed', turn: Math.ceil(proposed.length / 2), page_type: page.type });
      const started = Date.now();
      let newest = null;
      const slow = setTimeout(() => { dots.setAttribute('aria-label', L.slow); }, 8000);
      const ctrl = new AbortController(); const timer = setTimeout(() => ctrl.abort(), 30000);
      try {
        const endpoint = new URL(root.dataset.endpoint || '');
        if (endpoint.protocol !== 'https:') throw new Error('endpoint');
        const res = await fetch(endpoint.href, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ messages: proposed, sessionId: state.sessionId, page }), signal: ctrl.signal });
        const ans = await res.json().catch(() => null);
        if (!ans || typeof ans.message !== 'string') throw new Error('bad');
        const recs = (Array.isArray(ans.recommendations) ? ans.recommendations : []).filter((r) => r && typeof r.handle === 'string' && typeof r.name === 'string').slice(0, 3);
        const links = (Array.isArray(ans.links) ? ans.links : []).filter((l) => l && typeof l.url === 'string' && typeof l.name === 'string').slice(0, 3);
        const entry = { role: 'assistant', text: ans.message.slice(0, 2000), recs, links };
        dots.remove();
        state.transcript.push(entry);
        const mark = log.childElementCount;
        renderEntry(entry);
        newest = log.children[mark] || null;
        const memory = ans.message + (recs.length ? '\n[Shown: ' + recs.map((r) => r.handle).join(', ') + ']' : '');
        state.messages = [...proposed, { role: 'assistant', content: memory }].slice(-20);
        if (typeof ans.sessionId === 'string' && ans.sessionId.length < 100) state.sessionId = ans.sessionId;
        state.suggestions = (Array.isArray(ans.suggestions) ? ans.suggestions : []).filter((s) => typeof s === 'string').slice(0, 3);
        renderChips(state.suggestions);
        save();
        track('reply', { recommendations: recs.length, handles: recs.map((r) => r.handle).join(','), ms: Date.now() - started });
      } catch (e) {
        dots.remove();
        state.transcript.pop();
        if (!hidden) { const s = el('p', 'edca-status', L.unavailable); log.append(s); input.value = text; autosize(); }
        renderChips(state.transcript.length ? state.suggestions || [] : L.chips);
        track('error', { reason: e && e.name === 'AbortError' ? 'timeout' : 'request' });
      } finally {
        clearTimeout(slow); clearTimeout(timer);
        busy = false; send.disabled = false; reset.disabled = false;
        if (newest) log.scrollTop += newest.getBoundingClientRect().top - log.getBoundingClientRect().top - 8; else log.scrollTop = log.scrollHeight;
        if (!panel.hidden && !matchMedia('(max-width:600px)').matches) input.focus({ preventScroll: true });
      }
    }
    function autosize() { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight + 2, 120) + 'px'; }

    /* ---------- wiring ---------- */
    launch.addEventListener('click', () => open());
    close.addEventListener('click', shut);
    dismiss.addEventListener('click', hideForVisit);
    reset.addEventListener('click', () => {
      if (busy) return;
      state = { sessionId: null, messages: [], transcript: [], suggestions: null }; store.del(KEY);
      renderAll(); updateLauncher(); input.focus(); track('reset');
    });
    root.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) { e.preventDefault(); shut(); } });
    form.addEventListener('submit', (e) => { e.preventDefault(); ask(input.value); });
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); ask(input.value); } });
    input.addEventListener('input', autosize);
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-open-coin-advisor]');
      if (!t) return;
      e.preventDefault();
      track('cta_click', { cta: t.dataset.openCoinAdvisor || 'link' });
      open(t.dataset.advisorPrompt || '');
    });

    palette();
    updateLauncher();
    showLauncher(!store.get('edca-hidden', 0));
    lift();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true }); else mount();
  document.addEventListener('shopify:section:load', mount);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
